import { useContext, useState } from "react";
import { LocaleContext } from "../../contexts/LocaleContext";
import { useNavigate } from "react-router-dom";
import { blockUserService } from "../../services/blockUserService";
import { toast } from "../../services/toastService";
import BackButton from "../../components/common/BackButton";

const BlockUserForm = () => {
  const { t } = useContext(LocaleContext);
  const navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);

  const [form, setForm] = useState({
    phoneNumberCode: "+966",
    mobileNumber: "",
  });

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const showBackendErrors = (data) => {
    if (Array.isArray(data?.errors) && data.errors.length > 0) {
      data.errors.forEach((err) => toast.error(err));
    } else if (data?.message) {
      toast.error(data.message);
    } else {
      toast.error(t("anErrorOccurredPleaseTryAgainLater"));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.mobileNumber.trim()) {
      toast.error(t("phoneNumberIsRequired"));
      return;
    }
    setBtnLoading(true);
    try {
      const payload = {
        mobileNumber: `${form.phoneNumberCode}${form.mobileNumber}`.trim(),
      };
      const response = await blockUserService.block(payload);
      if (response?.isSuccess) {
        toast.success(t("recordSavedSuccessfully"));
        navigate("/block-users");
      } else {
        showBackendErrors(response);
      }
    } catch (error) {
      showBackendErrors(error?.response?.data);
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <section className="section-block-user-form">
      <div className="default-heading">{t("blockUsers")}</div>
      <form onSubmit={handleSubmit}>
        <div className="my-card">
          <div className="my-card-header d-flex justify-content-between align-items-center">
            <span><i className="fas fa-ban"></i> {t("addNewBlock")}</span>
            <BackButton />
          </div>
          <div className="my-card">
            <div className="my-card-header text-primary">{t("basicInformation")}</div>
            <div className="row">
              <div className="col-12 col-md-6">
                <div className="form-group">
                  <label className="form-label">{t("mobileNumber")} *</label>
                  <div className="d-flex gap-2">
                    <input
                      type="text"
                      className="form-control"
                      value={form.phoneNumberCode}
                      onChange={(e) => handleChange("phoneNumberCode", e.target.value)}
                      style={{ maxWidth: "80px" }}
                      placeholder="+966"
                    />
                    <input
                      type="text"
                      className="form-control"
                      value={form.mobileNumber}
                      onChange={(e) => handleChange("mobileNumber", e.target.value)}
                      placeholder={t("mobileNumber")}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-3 gap-2 d-flex justify-content-end">
            {btnLoading ? (
              <button type="button" className="btn-default">
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              </button>
            ) : (
              <button type="submit" className="btn-default">
                <i className="fas fa-ban"></i> {t("block")}
              </button>
            )}
            <a href="/block-users" className="btn-secondary">{t("cancel")}</a>
          </div>
        </div>
      </form>
    </section>
  );
};

export default BlockUserForm;
